import React from 'react';
import styled from 'styled-components';
import { enhancedTextContrast } from '../../styles/contrastUtils';
import { ModalProps } from '../../types/category';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000; /* Z-index encore plus élevé pour être au-dessus de tous les éléments */
  
  /* Centrage parfait sans décalage */
  padding: 0;
  margin: 0;
  width: 100vw; /* Assure que l'overlay couvre toute la largeur */
  height: 100vh; /* Assure que l'overlay couvre toute la hauteur */
`;

const ModalContent = styled.div<{ $backgroundColor?: string }>`
  background: ${props => props.$backgroundColor ? props.$backgroundColor : 'white'};
  padding: 20px;
  border-radius: 8px;
  min-width: 280px;
  max-width: 85%;
  max-height: 85vh;
  overflow-y: auto; /* Permet le défilement vertical */
  overflow-x: hidden; /* Supprime la barre de défilement horizontale */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  ${enhancedTextContrast} /* Utiliser notre utilitaire pour garantir le contraste */
  
  /* Style de la scrollbar - très discrète */
  &::-webkit-scrollbar {
    width: 3px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  @media (max-width: 480px) {
    min-width: auto;
    width: 85%;
    padding: 15px;
  }
`;

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, backgroundColor }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent 
        onClick={e => e.stopPropagation()}
        $backgroundColor={backgroundColor}
      >
        {children}
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;

